import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const DeviceVerbsExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Verbs for Describing Device Actions</h2>
      <p>
        These verbs describe what machines and devices do, from simple movements to complex
        processes like converting energy or directing signals. Use them to explain how things work.
      </p>

      <h3><FaLightbulb /> Common device verbs</h3>
      <div className="grammar-flex-table">
        {[
          ['Verb', 'Meaning', 'Example'],
          ['Convert', 'Change from one form to another', 'A solar panel converts sunlight into electricity.'],
          ['Deposit', 'Lay down in a particular place', 'A 3D printer deposits layers of material.'],
          ['Direct', 'Control the operation or direction of', 'A remote control directs signals to the TV.'],
          ['Emit', 'Produce and discharge', 'A smoke detector emits an alarm.'],
          ['Release', 'Allow to move or flow freely', 'A washing machine releases detergent into the drum.'],
          ['Transmit', 'Pass on from one place to another', 'A Wi-Fi router transmits internet signals.'],
          ['Operate', 'Control the functioning of', 'This device operates silently.'],
          ['Process', 'Perform operations on', 'The computer processes data quickly.'],
          ['Detect', 'Discover or identify the presence of', 'A sensor detects changes in temperature.'],
          ['Activate', 'Make active or operative', 'Press this button to activate the mechanism.'],
        ].map(([verb, meaning, example], index) => (
          <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
            <div className="grammar-cell">{verb}</div>
            <div className="grammar-cell">{meaning}</div>
            <div className="grammar-cell">{example}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeviceVerbsExplanation;
